var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[(_vm.vimeoId)?_c('vimeo-video',{attrs:{"id":_vm.vimeoId,"privacyId":_vm.privacyId,"maxHeight":_vm.maxHeight}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }